import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { a as EGDSIcon, E as EGDSIconSize } from '../icon/index-chunk.esm.js';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-price-lockup.css';
const getClassNameList = classNames.bind(styles);
var EGDSPriceLockupAlign;
(function (EGDSPriceLockupAlign) {
  EGDSPriceLockupAlign["LEFT"] = "start";
  EGDSPriceLockupAlign["RIGHT"] = "end";
})(EGDSPriceLockupAlign || (EGDSPriceLockupAlign = {}));
const RenderStrikeThroughTrigger = props => {
  const {
    strikeThroughPrice,
    strikeThroughTrigger,
    a11yStrikeThroughDialogTrigger,
    stids
  } = props;
  const infoIcon = jsx(EGDSIcon, {
    name: "info_outline",
    size: EGDSIconSize.SMALL
  });
  const strikeThroughElement = jsx("span", {
    "data-stid": stids?.strikeThroughId || '',
    children: strikeThroughPrice
  });
  const triggerChildren = [infoIcon, strikeThroughElement];
  const childrenArray = React.Children.toArray(strikeThroughTrigger);
  const firstChild = childrenArray[0];
  let triggerClassName = '';
  if (firstChild.props.className) {
    triggerClassName = firstChild.props.className;
  }
  const strikeThroughClassNames = getClassNameList('uitk-price-strikethrough', triggerClassName);
  const decoratedTrigger = React.cloneElement(strikeThroughTrigger, {
    'aria-label': a11yStrikeThroughDialogTrigger,
    className: strikeThroughClassNames
  },
  // @ts-ignore
  ...triggerChildren);
  return decoratedTrigger;
};
RenderStrikeThroughTrigger.displayName = 'RenderStrikeThroughTrigger';
class EGDSPriceLockup extends React.Component {
  static displayName = 'EGDSPriceLockup';
  static defaultProps = {
    align: EGDSPriceLockupAlign.RIGHT,
    isPointsFirst: false,
    isStrikeThroughFirst: false
  };
  static priceSubtextBaseClassName = 'uitk-price-subtext';
  priceSubtext(subtext, isPadded, stid) {
    const paddingClass = isPadded ? `${EGDSPriceLockup.priceSubtextBaseClassName}-padded` : `${EGDSPriceLockup.priceSubtextBaseClassName}-unpadded`;
    if (subtext.length > 0 && Array.isArray(subtext)) {
      const subtextList = subtext.map((text, index) => jsx("div", {
        className: getClassNameList(EGDSPriceLockup.priceSubtextBaseClassName),
        children: text
      }, `price-subtext-${index}`));
      return jsx("div", {
        "data-stid": stid || '',
        className: getClassNameList(paddingClass),
        "aria-hidden": "true",
        children: subtextList
      });
    }
    return jsx("div", {
      "data-stid": stid || '',
      className: getClassNameList(EGDSPriceLockup.priceSubtextBaseClassName, paddingClass),
      "aria-hidden": "true",
      children: subtext
    });
  }
  /**
   *
   * @deprecated UitkPriceLockup is deprecated, as it can be made
   * using readily available UITK components. A suitable pattern may be available
   * in the SharedUI library.
   */
  render() {
    const {
      className,
      align,
      lockupPrice,
      lockupFormattedPoints,
      strikeThroughPrice,
      priceSubtextFirst,
      priceSubtextBold,
      priceSubtextStandard,
      a11yPrice,
      a11yStrikeThroughDialogTrigger,
      strikeThroughTrigger,
      stids,
      isPointsFirst,
      leadingCaption,
      isStrikeThroughFirst
    } = this.props;
    const baseClass = 'uitk-price';
    const cssClassNames = getClassNameList(`${baseClass}-lockup`, className, align && `align-${align}`);
    const priceStrikethroughClassName = getClassNameList(`${baseClass}-strikethrough`);
    const lockupPointsClassName = getClassNameList('uitk-lockup-points');
    const lockupPriceClassName = getClassNameList('uitk-lockup-price');
    const subtextFirstStid = stids && stids.subtextFirstId;
    const subtextStandardStid = stids && stids.subtextStandardId;
    const wrapperComponent = (props, children, tag = 'div') => {
      if (!children) {
        return null;
      }
      const allProps = {
        ...props,
        'aria-hidden': 'true'
      };
      const components = {
        div: jsx("div", {
          ...allProps,
          children: children
        }),
        span: jsx("span", {
          ...allProps,
          children: children
        })
      };
      return components[tag] || null;
    };
    return jsxs("div", {
      className: cssClassNames,
      ...(stids && stids.wrapperId && {
        'data-stid': stids.wrapperId
      }),
      children: [isStrikeThroughFirst && strikeThroughTrigger && strikeThroughPrice && a11yStrikeThroughDialogTrigger && jsx(RenderStrikeThroughTrigger, {
        strikeThroughPrice: strikeThroughPrice,
        strikeThroughTrigger: strikeThroughTrigger,
        a11yStrikeThroughDialogTrigger: a11yStrikeThroughDialogTrigger,
        stids: stids
      }), isStrikeThroughFirst && strikeThroughPrice && !strikeThroughTrigger && wrapperComponent({
        'data-stid': stids?.strikeThroughId || '',
        className: priceStrikethroughClassName
      }, strikeThroughPrice, 'span'), isPointsFirst && lockupFormattedPoints && wrapperComponent({
        'data-stid': stids?.lockupFormattedPointsId || '',
        className: lockupPointsClassName
      }, lockupFormattedPoints, 'div'), jsxs("section", {
        children: [jsx("span", {
          className: getClassNameList(`${baseClass}-a11y`, 'is-visually-hidden'),
          children: a11yPrice
        }), !isStrikeThroughFirst && strikeThroughTrigger && strikeThroughPrice && a11yStrikeThroughDialogTrigger && jsx(RenderStrikeThroughTrigger, {
          strikeThroughPrice: strikeThroughPrice,
          strikeThroughTrigger: strikeThroughTrigger,
          a11yStrikeThroughDialogTrigger: a11yStrikeThroughDialogTrigger,
          stids: stids
        }), !isStrikeThroughFirst && strikeThroughPrice && !strikeThroughTrigger && wrapperComponent({
          'data-stid': stids?.strikeThroughId || '',
          className: priceStrikethroughClassName
        }, strikeThroughPrice, 'span'), isPointsFirst && leadingCaption && wrapperComponent({
          className: lockupPriceClassName
        }, leadingCaption, 'span'), lockupPrice && wrapperComponent({
          'data-stid': stids?.lockupId || '',
          className: lockupPriceClassName
        }, lockupPrice, 'span')]
      }), !isPointsFirst && lockupFormattedPoints && wrapperComponent({
        'data-stid': stids && stids.lockupFormattedPointsId ? stids.lockupFormattedPointsId : '',
        className: lockupPointsClassName
      }, [leadingCaption, lockupFormattedPoints], 'div'), priceSubtextFirst && this.priceSubtext(priceSubtextFirst, false, subtextFirstStid), priceSubtextBold && jsx("div", {
        className: getClassNameList(EGDSPriceLockup.priceSubtextBaseClassName),
        "aria-hidden": "true",
        children: jsx("b", {
          "data-stid": stids?.subtextBoldId || '',
          children: priceSubtextBold
        })
      }), priceSubtextStandard && this.priceSubtext(priceSubtextStandard, true, subtextStandardStid)]
    });
  }
}
export { EGDSPriceLockupAlign as E, RenderStrikeThroughTrigger as R, EGDSPriceLockup as a };